import { natsort } from 'natsort-esm';

import { Address } from '@core/types/api/Address/Address';

import { hasStringValue } from './equality';

export const buildCountPhrase = (
  count: number,
  infix: string,
  singular: string,
  plural: string,
): string => {
  return [count.toString(), infix, count === 1 ? singular : plural].join(' ');
};

export const requiredLabel = (label: string, required: boolean | undefined): string => {
  return required ? `${label}*` : label;
};

export const splitCommaSeparatedList = (value: string | null | undefined): string[] => {
  if (!value || value.trim() === '') {
    return [];
  }
  return value
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);
};

export const formatAddressToString = (address: Address): string => {
  return [
    address.line1,
    address.line2,
    address.city,
    address.state,
    address.postalCode,
    address.country,
  ]
    .filter(hasStringValue)
    .join(', ');
};

// Orders numbers embedded in strings by value, so "Policy 2" sorts before "Policy 10".
export const compareStringsAsc = natsort({ tokenizeWholeNumbersOnly: true });
